import React, { useState } from "react"
import { Navigate } from "react-router-dom"

// Profile
import Reports from "pages/Reports/Reports/index"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
// Teams
import Roles from "pages/RolesRespons"
import EditRoles from "pages/RolesRespons/EditRoles"
import AddRoles from "pages/RolesRespons/AddRoles"
import Staff from "pages/Staff/index"
import AddStaff from "pages/Staff/AddStaff"
import EditStaff from "pages/Staff/EditStaff/EditStaff"

// setting Module
import CompanySettingIndex from "pages/Setting/CompanySettings"

// setting
import AddRolesDynamic from "pages/RolesRespons/AddRolesDynamic"
import AccessDenied from "./AccessDenied"
import configure from "configure"
import Crendential from "pages/Credentials/Crendential"
import Profile from "pages/Profile/Profile"

import RolesPermission from "pages/AuditLog/RolesPermission"


// Work -> General Settings
import SwipeAndIssuesIndex from "pages/HumanResources/Swipe_and_Issues/SwipeAndIssuesIndex"
import ViewApproveDoc from "pages/Dashboard/ViewApproveDoc"
import DragDashboard from "pages/Dashboard/DragDashboard"
import NotificationPage from "pages/Setting/NotificationPage"
import SalaryIndex from "pages/HumanResources/Payroll Management/SalaryProcess/SalaryIndex"
import SalarySlip from "pages/HumanResources/Payroll Management/SalarySlip/SalarySlip"
import GeneratedSalarySlip from "pages/HumanResources/Payroll Management/SalarySlip/GeneratedSalarySlip"
import LeaveManagement from "pages/HumanResources/Payroll Management/LeaveManagement/LeaveManagement"
import HrReport from "pages/HumanResources/Report/HrReport"
import ListOfHolidays from "pages/HumanResources/Holidays/ListOfHoliday"
import DevResourceIndex from "pages/WorkModule/Resource/Develop Resource/DevResourceIndex"
import ProjectIndex from "pages/WorkModule/Projects/ProjectIndex"
import EditProject from "pages/WorkModule/Projects/EditProject/EditProject"
import AddProject from "pages/WorkModule/Projects/AddProject"


const authProtectedRoutes = [
  {
    path: `${configure.appUrl}dashboard`,
    component: <DragDashboard />,
    // component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
    // component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },
  {
    path: `${configure.appUrl}roles`,
    component: <Roles />,
    module_id: "69",
    type: "view",
  },
  {
    path: `${configure.appUrl}editroles/:id`,
    component: <EditRoles />,
    module_id: "69",
    type: "edit",
  },
  {
    path: `${configure.appUrl}addroles`,
    component: <AddRoles />,
    module_id: "69",
    type: "add",
  },
  {
    path: `${configure.appUrl}addroles/:slug`,
    component: <AddRolesDynamic />,
    module_id: "69",
    type: "add",
  },
  {
    path: `${configure.appUrl}staff`,
    component: <Staff />,
    module_id: "66",
    type: "view",
  },
  {
    path: `${configure.appUrl}addstaff`,
    component: <AddStaff />,
    module_id: "66",
    type: "add",
  },
  {
    path: `${configure.appUrl}edit-staff/:id`,
    component: <EditStaff />,
    module_id: "66",
    type: "edit",
  },
  {
    path: `${configure.appUrl}viewapprovedoc/:id`,
    component: <ViewApproveDoc />,
    module_id: "66",
    type: "edit",
  },

  // setting module
  {
    path: `${configure.appUrl}setting/companysetting`,
    component: <CompanySettingIndex />,
    moduleid: "70",
    type: "view",
  },
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  },
  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },
  {
    path: `${configure.appUrl}audit/roles`,
    component: <RolesPermission />,
  },

  // Audit Logs route
  {
    path: `${configure.appUrl}audit-log/rolespermission`,
    component: <RolesPermission />,
  },

  // Human Resource

  {
    path: `${configure.appUrl}payroll_management/swipe_issues`,
    component: <SwipeAndIssuesIndex />,
  },
  {
    path: `${configure.appUrl}flaws-gap`, component: <Reports />,
    module_id: "96",
    type: "view",
  },
  {
    path: `${configure.appUrl}notifications`,
    component: <NotificationPage />
  },

  // Human Resource

  {
    path: `${configure.appUrl}payroll-management/salary-process`,
    component: <SalaryIndex />,
    module_id: 109,
    type: "view",
  },
  {
    path: `${configure.appUrl}payroll-management/salary-slip`,
    component: <SalarySlip />,
    module_id: 108,
    type: "view",
  },
  {
    path: `${configure.appUrl}generate-salary-slip/:id`,
    component: <GeneratedSalarySlip />,
    module_id: 108,
    type: "view",
  },
  {
    path: `${configure.appUrl}payroll-management/leave-management`,
    component: <LeaveManagement />,
    module_id: 40,
    type: "view",
  },

  // Reports
  {
    path: `${configure.appUrl}hr-report`,
    component: <HrReport />,
    module_id: 111,
    type: "view",
  },

  // List of Holidays
  {
    path: `${configure.appUrl}holiday_list`,
    component: <ListOfHolidays />,
    module_id: "38",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/projects`,
    component: <ProjectIndex />,
    module_id: "25",
    type: "view",
  },
  {
    path: `${configure.appUrl}work/edit-project/:id`,
    component: <EditProject />,
    module_id: "25",
    type: "edit",
  },
  {
    path: `${configure.appUrl}work/add-project`,
    component: <AddProject />,
    module_id: "25",
    type: "add",
  },
]


const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },
]

export { authProtectedRoutes, publicRoutes }
